<template>
  <!-- Only show this label when editing the page -->
  <div v-if="isEditing">
    {{ `Structured Data - Website: ${fields?.name?.value}` }}
  </div>
</template>

<script>
import { useHead } from '@unhead/vue';
import structuredData from '../../../lib/structuredData';

export default {
  name: 'CIS-StructuredData-Website',
  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props) {
    useHead({
      script: [structuredData(props.fields, 'website')]
    });
  },
  computed: {
    isEditing() {
      return this.$jss.sitecoreContext().pageEditing;
    }
  }
};
</script>
